import { Injectable } from '@angular/core';
import { environment } from 'src/app/environments/environment';
import { getAuth, signOut } from 'firebase/auth';
import { Auth, sendPasswordResetEmail, verifyPasswordResetCode, confirmPasswordReset } from '@angular/fire/auth';

import {
  collection
} from '@firebase/firestore';

import {
  Firestore,
  getDocs,
  doc,
  setDoc
} from '@angular/fire/firestore';

import { Router } from '@angular/router';

import { FirestoreService } from './firestore.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private afs: Firestore,
    private router: Router,
    private firestoreservice: FirestoreService,
    private auth: Auth
  ) { }
  userdetails: any = {};
  updateUserCollection =
    async (credential: any, userdetails: any) => {
      console.log(credential);
      console.log(userdetails);


      this.userdetails = userdetails

      if (credential.email) {
        this.userdetails.emailid = credential.email;
      }
      this.userdetails.createdAt = credential.metadata.creationTime;
      console.log(this.userdetails);
      // return
      return new Promise(async (resolve, reject) => {
        const userRef = doc(this.afs, 'contractors-list', credential.uid);
        const alignmasteruserRef = doc(this.afs, 'users-list', credential.uid);
        try {

          await setDoc(alignmasteruserRef, this.userdetails).then(() => {
            resolve(true);
          });
        } catch (e: any) {
          console.error(e.message);
          resolve(false);
        }
      });
    };
  userSignOut() {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        // Save the current language preference
        const lang = localStorage.getItem('lang');
        localStorage.clear();
        if (lang) {
          localStorage.setItem('lang', lang);
        }

        // Clear all session storage
        sessionStorage.clear();

        // Perform a full reload by redirecting to '/'
        window.location.href = '/';
      })
      .catch((error) => {
        console.error('Logout error:', error);
      });
  }

  async copyCollection(
    sourceCollection: string,
    destinationCollection: string
  ) {
    const sourceCollectionRef = collection(this.afs, sourceCollection);
    const destinationCollectionRef = collection(
      this.afs,
      destinationCollection
    );

    try {
      const snapshot = await getDocs(sourceCollectionRef);

      snapshot.forEach(async (ddoc) => {
        const data = ddoc.data();
        console.log('data: ', data);
        const id = ddoc.id;
        // const datalistref = (doc(this.afs, destinationCollection, id));
        // const docsnap = await getDoc(datalistref);
        if (ddoc.exists()) {
          // const datalistref = doc(this.afs, destinationCollection, doc.id);
          const docsnap = await setDoc(
            doc(this.afs, destinationCollection, ddoc.id),
            Object.assign({}, ddoc.data()),
            { merge: true }
          );
        }
      });

      console.log('Collection copied successfully!');
    } catch (error) {
      console.error('Error copying collection:', error);
    }
  }

  // --- Password Reset Methods ---
  sendPasswordReset(email: string) {
    const actionCodeSettings = {
      url: `${environment.appUrl}/auth/login`,
      handleCodeInApp: true,
    };
    return sendPasswordResetEmail(this.auth, email, actionCodeSettings);
  }

  verifyResetCode(oobCode: string) {
    return verifyPasswordResetCode(this.auth, oobCode);
  }

  confirmPasswordReset(oobCode: string, newPassword: string) {
    return confirmPasswordReset(this.auth, oobCode, newPassword);
  }
}
